import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import EmptyState from '../components/ui/EmptyState';
import Button from '../components/ui/Button';
import { useT } from '../i18n/LocaleContext';

export default function ForbiddenPage() {
  const t = useT();
  const navigate = useNavigate();
  const location = useLocation();
  const needed = location.state?.permission;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <EmptyState
        icon="🔒"
        title={t('pages.forbidden.title')}
        body={
          needed
            ? `${t('pages.forbidden.subtitle')} — ${t('forbidden.need_permission', { permission: needed })}`
            : t('pages.forbidden.subtitle')
        }
        action={<Button variant="gold" onClick={() => navigate('/dashboard')}>{t('forbidden.back_home')}</Button>}
      />
    </div>
  );
}
